import React, { useEffect, useState } from "react";
import TabBar from "@/components/tabBar/TabBar";
import { Loader } from "@/assets/icon/loader";
import { useTranslation } from "react-i18next";
import BillsService, {
  INotices,
} from "@/api-client/api/services/billsService/billsService";
import HeaderCommon from "@/components/header/HeaderCommon";
import Chip, { ChipStatusEnum } from "@/components/customComponents/Chip";

const News: React.FC = () => {
  const { t } = useTranslation();

  const [news, setNews] = useState<INotices[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchNews = async () => {
    try {
      const news = await BillsService.getNotices();
      setNews(news);
    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const NewsCard = ({ item }: { item: INotices }) => {
    const date = new Date(item.created_at);

    const month = date.toLocaleString("en-US", { month: "short" });
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const formatted = `${month} ${day} at ${hours}:${minutes}`;

    return (
      <div
        className={`flex flex-col min-h-[315px] font-medium bg-[#0027CB0D] rounded-[16px] px-2 py-2 gap-2 ${
          item.is_emergency ? "bg-[#FF00000D]" : "bg-[#0027CB0D]"
        }`}
      >
        <div className="flex items-center justify-between">
          {item.is_emergency ? (
            <Chip text={t("emergency")} status={ChipStatusEnum.RED} />
          ) : (
            <div className="h-[20px]" />
          )}
        </div>
        <div className="flex flex-1 flex-col gap-2 px-2">
          <span className="text-[15px]">{item.title}</span>
          <span className="text-[12px] flex-1">{item.description}</span>
          <div className="flex flex-col gap-2 text-[#00000080] ">
            <span>
              {t("house_manager.address")} - {item.building.address}
            </span>
            <span className="text-[12px]">{formatted}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="h-[100%] flex flex-row p-4 gap-6">
      <TabBar />
      <div className="w-full flex flex-col gap-[20px]">
        <div className="flex row items-center justify-between ml-4">
          <p id="title_bills" className="font-medium text-[20px]">
            {t("sideBar.news_butt")}
          </p>
          <HeaderCommon />
        </div>

        <div className="flex flex-col gap-4 ml-4 mb-10">
          <div className="flex flex-row gap-2 items-center">
            <div className="text-[24px] font-medium">
              {t("house_manager.notices_and_news")}
            </div>
            {news.length ? (
              <span className="px-2 rounded-[20px] text-[16px] text-[#00000080] bg-[#F5F5F5]">
                {news.length}
              </span>
            ) : (
              <Chip
                text={t("house_manager.no_news")}
                status={ChipStatusEnum.GREY}
              />
            )}
          </div>
          {!isLoading ? (
            <div>
              {news.length ? (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2">
                  {news.map((item) => (
                    <NewsCard item={item} key={item.id} />
                  ))}
                </div>
              ) : (
                <span>{t("no_data")}</span>
              )}
            </div>
          ) : (
            <div className="mx-auto">
              <Loader isGrey />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default News;
